import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import * as base64 from "../util/base64";
import { Constants } from "../util/constants";
import { HttpHeaders } from "../httpHeaders";
var HeaderConstants = Constants.HeaderConstants;
var DEFAULT_AUTHORIZATION_SCHEME = "Basic";
/**
 * A simple {@link ServiceClientCredential} that authenticates with a username and a password.
 */

export var BasicAuthenticationCredentials = /*#__PURE__*/function () {
  /**
   * Creates a new BasicAuthenticationCredentials object.
   *
   * @param userName - User name.
   * @param password - Password.
   * @param authorizationScheme - The authorization scheme.
   */
  function BasicAuthenticationCredentials(userName, password) {
    var authorizationScheme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_AUTHORIZATION_SCHEME;

    _classCallCheck(this, BasicAuthenticationCredentials);

    /**
     * Authorization scheme. Defaults to "Basic".
     * More information about authorization schemes is available here: https://developer.mozilla.org/docs/Web/HTTP/Authentication#authentication_schemes
     */
    this.authorizationScheme = DEFAULT_AUTHORIZATION_SCHEME;

    if (userName === null || userName === undefined || typeof userName.valueOf() !== "string") {
      throw new Error("userName cannot be null or undefined and must be of type string.");
    }

    if (password === null || password === undefined || typeof password.valueOf() !== "string") {
      throw new Error("password cannot be null or undefined and must be of type string.");
    }

    this.userName = userName;
    this.password = password;
    this.authorizationScheme = authorizationScheme;
  }
  /**
   * Signs a request with the Authentication header.
   *
   * @param webResource - The WebResourceLike to be signed.
   * @returns The signed request object.
   */


  _createClass(BasicAuthenticationCredentials, [{
    key: "signRequest",
    value: function signRequest(webResource) {
      var credentials = "".concat(this.userName, ":").concat(this.password);
      var encodedCredentials = "".concat(this.authorizationScheme, " ").concat(base64.encodeString(credentials));
      if (!webResource.headers) webResource.headers = new HttpHeaders();
      webResource.headers.set(HeaderConstants.AUTHORIZATION, encodedCredentials);
      return Promise.resolve(webResource);
    }
  }]);

  return BasicAuthenticationCredentials;
}();